import { DeviceClaimProgress, MacSerialNumberDevice } from '@shure/cloud/shared/models/devices';

import { ClaimStatusCellData, mapClaimResultToProgressCellData } from './claim-status-cell-data';

export interface MacSerialConfirmationTableRowData {
	id: string;
	claimStatusCellData: ClaimStatusCellData;
	macAddress: string;
	serialNumber: string;
	status: string;
}

export function mapMacSerialClaimDataToMacSerialConfirmationTableRowData(
	data: DeviceClaimProgress<MacSerialNumberDevice>['devices'][0][]
): MacSerialConfirmationTableRowData[] {
	return data.map((d) => mapMacSerialClaimDeviceToMacSerialConfirmationTableRowData(d));
}

function mapMacSerialClaimDeviceToMacSerialConfirmationTableRowData(
	deviceData: DeviceClaimProgress<MacSerialNumberDevice>['devices'][0]
): MacSerialConfirmationTableRowData {
	const claimStatusCellData: ClaimStatusCellData = {
		id: deviceData.device.device.id,
		...mapClaimResultToProgressCellData(deviceData.result)
	};

	const rowData: MacSerialConfirmationTableRowData = {
		id: deviceData.device.device.id,
		claimStatusCellData,
		macAddress: deviceData.device.device.macAddress,
		serialNumber: deviceData.device.device.serialNumber,
		status: deviceData.result
	};

	return rowData;
}
